import React from 'react'
import { Controller } from 'react-hook-form'
import cx from 'classnames'
import * as R from 'ramda'

import type { ControlledFieldProps, FormFieldBaseProps } from '../../types'
import styles from './Input.module.scss'

type InputProps = FormFieldBaseProps & {
  min?: number | string
  max?: number | string
  placeholder?: string
  type?: string
  value?: string | number
  onBlur?: React.FocusEventHandler<HTMLInputElement>
  onFocus?: React.FocusEventHandler<HTMLInputElement>
  onChange?: React.ChangeEventHandler<HTMLInputElement>
  isReadOnly?: boolean
}

export const Input = React.forwardRef<HTMLInputElement, InputProps>(
  (
    {
      error,
      fieldClassName,
      id,
      min,
      max,
      name,
      placeholder,
      type = 'text',
      value,
      onBlur,
      onFocus,
      onChange,
      isDisabled = false,
      isReadOnly = false,
      isRequired = false,
    },
    ref,
  ) => (
    <input
      className={cx(styles.input, fieldClassName, {
        [styles.invalid]: Boolean(error),
      })}
      disabled={isDisabled}
      readOnly={isReadOnly}
      required={isRequired}
      {...(R.includes(type, ['date', 'number']) && { min, max })}
      {...{
        id,
        name,
        placeholder,
        ref,
        type,
        value,
        onBlur,
        onFocus,
        onChange,
      }}
    />
  ),
)

type ControlledInputProps = ControlledFieldProps &
  Pick<InputProps, 'min' | 'max' | 'placeholder' | 'type' | 'isReadOnly'>

export const ControlledInput = ({
  control,
  error,
  fieldClassName,
  id,
  min,
  max,
  name,
  placeholder,
  type,
  isDisabled,
  isReadOnly,
  isRequired,
}: ControlledInputProps) => (
  <Controller
    render={({ field: { name, ref, value, onBlur, onChange } }) => (
      <Input
        {...{
          error,
          fieldClassName,
          id,
          min,
          max,
          name,
          placeholder,
          ref,
          type,
          value,
          onBlur,
          onChange,
          isDisabled,
          isReadOnly,
          isRequired,
        }}
      />
    )}
    {...{ control, name }}
  />
)
